import type { SpecificationContentType } from '../enums';
import type { SpecificationSection } from '@/domains/specification/services/specification-section';

export interface GenerateQueueTask {
    handler: (section: SpecificationSection) => Promise<void>;
    contentType: SpecificationContentType;
}

export const SpecificationSectionManager = Symbol.for('SpecificationSectionManager');

export interface SpecificationSectionManager {
    generateQueue: GenerateQueueTask[];
    addTask(...tasks: GenerateQueueTask[]): SpecificationSectionManager;
    prependTask(...tasks: GenerateQueueTask[]): SpecificationSectionManager;
    hasTask(): boolean;
    nextTask(): GenerateQueueTask | undefined;
    clearTasks(): void;
}
